// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","deprecatedFormat":"CustomExtendedDataField_deprecatedFormat__Pw4Db"};